// Spacer.tsx - Polymorphic component for creating space between elements
import React from "react";
import Box from "../Box/Box";
import { SpacerBaseProps, SpacerComponent } from "./Spacer.types";

/**
 * Spacer component - Creates empty space in layouts
 *
 * @example
 * // Vertical space (default)
 * <Spacer size="large" />
 *
 * // Horizontal space
 * <Spacer axis="horizontal" size={8} />
 *
 * // Space in both directions
 * <Spacer axis="both" size="medium" />
 *
 * // As a semantic element
 * <Spacer as="span" axis="horizontal" size="small" />
 */
export const Spacer = function Spacer(
  props: SpacerBaseProps & { as?: React.ElementType }
) {
  const { size = 4, axis = "vertical", as, ...rest } = props;

  // Set width and height based on axis
  const width = axis === "horizontal" || axis === "both" ? size : undefined;
  const height = axis === "vertical" || axis === "both" ? size : undefined;

  return (
    <Box
      as={as}
      width={width}
      height={height}
      flexShrink={0}
      {...(rest as Record<string, unknown>)}
    />
  );
} as SpacerComponent;

// Set display name for debugging
Spacer.displayName = "Spacer";

export default Spacer;
